import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'AnalysisMixin',
})
export default class extends Vue {
  get storeSid() {
    return AppModule.sid;
  }

  get storeSessionId() {
    return AppModule.setting?.session_id;
  }

  async setAnalysis(tab: number) {
    const session = await this.waitForSessionId();
    await AppModule.getAnalysis({
      sid: this.storeSid,
      session,
      tab,
    });
  }

  // session_id arrives asynchronously with the portal settings, so on a fresh
  // page load it may not be ready when created()/mounted() fires. Wait for it
  // before sending, otherwise the first page view is lost with an empty session.
  private waitForSessionId(): Promise<any> {
    if (this.storeSessionId) {
      return Promise.resolve(this.storeSessionId);
    }
    return new Promise((resolve) => {
      const unwatch = this.$watch(
        () => AppModule.setting?.session_id,
        (value) => {
          if (value) {
            unwatch();
            resolve(value);
          }
        },
      );
    });
  }
}
